import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { SearchFilterButton } from "../../index";
import { SFiltersGrid } from "./styles";

export interface FilterListType {
  funds: boolean;
  stocks: boolean;
  fixedIncome: boolean;
  pension: boolean;
}

interface SearchFilterListPropType {
  passSelectedToParent: React.Dispatch<React.SetStateAction<FilterListType>>;
}

export const SearchFilterList: React.FC<SearchFilterListPropType> = ({
  passSelectedToParent,
}) => {
  const theme = useTheme();
  const [searchFilters, setSearchFilters] = useState({
    funds: false,
    stocks: false,
    fixedIncome: false,
    pension: false,
  } as FilterListType);
  const { t } = useTranslation();

  useEffect(
    () => passSelectedToParent(searchFilters),
    [passSelectedToParent, searchFilters]
  );

  return (
    <SFiltersGrid>
      <SearchFilterButton
        id="funds"
        text={t("searchAsset.funds")}
        barColor={theme.colors.funds || "purple"}
        setFilterIsSelected={setSearchFilters}
      />
      <SearchFilterButton
        id="stocks"
        text={t("searchAsset.stocks")}
        barColor={theme.colors.stocks || "orange"}
        setFilterIsSelected={setSearchFilters}
      />
      <SearchFilterButton
        id="fixedIncome"
        text={t("searchAsset.fixedIncome")}
        barColor={theme.colors.fixedIncome || "pink"}
        setFilterIsSelected={setSearchFilters}
      />
      {/* <SearchFilterButton
        id="pension"
        text={t("searchAsset.pension")}
        barColor={theme.colors.pension || "green"}
        setFilterIsSelected={setSearchFilters}
      /> */}
    </SFiltersGrid>
  );
};
